// Photo Privacy Shield (frontend deterrents). The real, traceable watermark is
// burned server-side; this layer blocks casual right-click/drag/long-press saves
// and shows a subtle repeating watermark overlay.
export function ProtectedMedia({ children, className = "" }) {
  return (
    <div
      className={`mj-protected ${className}`}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      data-testid="protected-media"
    >
      {children}
      <div className="mj-watermark" aria-hidden="true" />
    </div>
  );
}
